// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__PoQL9","content":"Welcome_content__-QYVa","animate":"Welcome_animate__fWdBu","image":"Welcome_image__07xcn","floating":"Welcome_floating__JT9uL"};